import React, { Component } from 'react';
import Map from './Map';

import urlThunderStorm from './assets/SVG/thunder.svg'; 
import urlDrizzle from './assets/SVG/rain.svg';  
import urlSnow from './assets/SVG/snow.svg'; 
import urlMist from './assets/SVG/mist.svg'; 
import urlTornado from './assets/SVG/tornado.svg'; 
import urlClear from './assets/SVG/clear_sky.svg';
import urlFewClouds from './assets/SVG/cloudy.svg';
import urlWarrning from './assets/IMG/warning.png';
 
class WeatherInfo extends Component {

    state = {
        date: new Date(),
        latitud: this.props.Data.coordLat,
        longitud: this.props.Data.coordLon, 
        url_icon: ''
    }

    decideUrlIcon(WeatherDescription) {           
        switch(WeatherDescription.toString().toLowerCase()) {
            case 'thunderstorm':
              return urlThunderStorm;
            case 'drizzle':
              return urlDrizzle;
            case 'rain':
              return urlDrizzle;              
            case 'snow':
              return urlSnow;
            case 'mist':
              return urlMist;   
            case 'smoke':
              return urlMist;                
            case 'haze':
              return urlMist;                
            case 'dust':
              return urlMist;                
            case 'fog':
              return urlMist;                
            case 'sand':
              return urlMist;                               
            case 'ash':
              return urlMist;  
            case 'squall':
              return urlMist;                              
            case 'tornado':
              return urlTornado;
            case 'clear':
              return urlClear;
            case 'clouds':
              return urlFewClouds;
            default:
                return urlWarrning;
          }     
    }

    render(){
        return(
            <div> 
                {   
                    this.props.Data.error &&
                    <div className="alert alert-danger mt-3" role="alert">
                        <p className="text-center">{this.props.Data.error}</p>
                    </div> 
                }
                {   
                    this.props.Data.could ?
                        <div className="row mx-auto">  
                            <div className="col-md-12 h5 bg-transparent shadow-lg p-3 mb-5 bg-white rounded mx-auto"> 
                                <div className="font-weight-bold"> { this.props.Data.nameCity }, { this.props.Data.country } </div>
                                <div> { this.state.date.toLocaleTimeString() } </div>                 
                                <div className="row"> 
                                    <div className="col-md-6 display-1 font-weight-bold mt-auto"> { this.props.Data.temp + "°"} </div>  
                                    <div className="col-md-6 d-flex justify-content-end">                                         
                                        <img className="img-thumbnail bg-transparent border-0" src={this.decideUrlIcon(this.props.Data.main)} alt="icon" width="200" height="200" /> 
                                    </div> 
                                </div>         
                                <div>{ this.props.Data.main }</div>                      
                                <div className="text-capitalize">{ this.props.Data.description }</div>                     
                            </div>

                            <div className="col-md-12  shadow-lg p-3 mb-5 bg-white rounded mx-auto"> 
                                <div className="row mx-auto">
                                    <div className="col-sm-8">
                                        <p className="h3"> Feel Like: { this.props.Data.feelLike +'°' }</p> 
                                        <p> Max. Temperature: { this.props.Data.tempMax + " °"}  </p>
                                        <p> Min. Temperature: { this.props.Data.tempMin + " °"}  </p>                                
                                        <p> Coulds: { this.props.Data.could }</p> 
                                    </div>
                                    <div className="col-sm-4">                                        
                                        <div className="font-weight-normal">
                                            <p> Humidity:  { this.props.Data.humidity }</p> 
                                            <p> wind Speed: { this.props.Data.windSpeed  + " mph"}</p>   
                                            <p> wind Direction: { this.props.Data.windDeg + " °"}</p>   
                                            <p> Pressure: { this.props.Data.pressure + " in"} </p>
                                        </div>                                  
                                    </div> 
                                </div>                                                                                   
                            </div>                              
                            <div className="col-md-12 p-0 mb-3 shadow-lg bg-white rounded mx-auto" >
                                <Map city={this.props.Data.city} latitud={this.props.Data.coordLat} longitud={this.props.Data.coordLon} />
                            </div>                                              
                        </div> 
                    :null
                }                
            </div>
        )
    }
}; 
export default WeatherInfo;   
